import script from "./PeriodMonthPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./PeriodMonthPicker.vue?vue&type=script&setup=true&lang=js"

import "./PeriodMonthPicker.vue?vue&type=style&index=0&id=daab9458&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-daab9458"]])

export default __exports__